
import { defineComponent, computed } from "vue";
import type { IStudentsModel } from "@/interfaces/modules/aula/IStudentsModel";

export default defineComponent({
  name: "TabContact",
  props: {
    record: { type: Object as () => IStudentsModel, required: true },
    wasValidated: { type: Boolean, default: false } // NEW: comes from parent
  },
  emits: ["update:record"],
  setup(props, { emit }) {
    // Two-way proxy for the record prop
    const recordProxy = computed<IStudentsModel>({
      get: () => props.record,
      set: (val) => emit("update:record", val),
    });

    // Immutable field update to ensure computed setter fires
    const updateField = (key: keyof IStudentsModel, value: any) => {
      recordProxy.value = { ...recordProxy.value, [key]: value };
    };

    return {
      recordProxy,
      updateField,
    };
  },
});
